import { Grid, IconButton, Menu, MenuItem, DialogContent, Typography, FormControlLabel, Checkbox } from '@material-ui/core';
import {
  Block,
  CreditCard,
  DateRangeRounded,
  Delete,
  Description as DescriptionIcon,
  DriveEta,
  Euro as EuroIcon,
  Height,
  HomeRounded,
  Language as LanguageIcon,
  LocalActivityRounded as LocalActivity,
  SchoolRounded as SchoolIcon,
} from '@material-ui/icons';
import DonutSmallIcon from '@material-ui/icons/DonutSmall';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import RoomIcon from '@material-ui/icons/Room';
import VisibilityIcon from '@material-ui/icons/Visibility';
import {
  checkIfPostuleOffer,
  checkIfSavedOffer,
  getInfosAccountRestricted,
  getInfosDashboard,
  getSchoolsPartners,
  connectABusinessPartner,
  postuleOffer,
  savedOffer,
  unSavedOffer,
} from '@webapps/business';
import {
  Button,
  useAuth,
  useMutation,
  useQuery,
  useRouter,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import AvatarCompany from 'components/Avatar/AvatarCompany';
import HourglassHalf from 'components/Icons/HourglassHalf';
import Partenaire from 'components/Icons/Partenaire';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import Token from 'components/Icons/Token';
import { ROUTES_PATH } from 'config/constants';
import parse from 'html-react-parser';
import theme from 'pages/MyMap/theme';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import Modal from 'components/Modal';
import { useCv } from 'pages/MyMap/Store/CvProvider';
import { linkifyText, linkifyTextReact } from '@webapps/utils';

const {
  colors: { background },
} = theme;

const Informations = ({
  partnersAccepted,
  partnersRequested,
  partnersReceived,
  accountInfos,
  info = {},
  userInfo = {},
}) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser, profile } = useAuth();

  const { addToast } = useToast();
  const { state, dispatch } = useCv();
  const [infosBusiness, setInfosBusiness] = useState({});
  const [openNeedCV, setOpenNeedCV] = useState(false);
  const [tempCv, setTempCv] = useState(null);
  const [useAsDefault, setUseAsDefault] = useState(false);
  const [deleteCvTemp, setDeleteCvTemp] = useState(false);

  const {
    isLoading: isLoadingSavedOffer,
    isSuccess: isSuccessSave,
    mutateAsync: mutateSavedOffer,
  } = useMutation(savedOffer);

  const {
    isLoading: isLoadingPostuleOffer,
    isSuccess: isSuccessPostule,
    mutateAsync: mutatePostuleOffer,
  } = useMutation(postuleOffer);

  const {
    isLoading: isLoadingUnSavedOffer,
    isSuccess: isSuccessUnSave,
    mutateAsync: mutateUnSavedOffer,
  } = useMutation(unSavedOffer);

  const { data: checkSave = {}, refetch } = useQuery(checkIfSavedOffer, {
    key: ['checkSavedOffer'] + idUser + info?.id,
    variables: { idApplicant: idUser, idOffer: info?.id },
  });

  const { data: checkPostule = {}, refetch: refetchPostule } = useQuery(
    checkIfPostuleOffer,
    {
      key: ['checkPostuleOffer'] + idUser + info?.id,
      variables: { idApplicant: idUser, idOffer: info?.id },
    }
  );

  const { data: tempInfosBusiness = {}, refetch: refetchInfosBusiness } = useQuery(
    getInfosDashboard,
    {
      key: 'infoDashboardBusiness',
      variables: { id: info?.business?.id },
      enabled: !!info?.business?.id,
    }
  );

  const { data: infoBusinessAccount = {} } = useQuery(getInfosAccountRestricted, {
    key: 'infoBusinessAccount' + info?.business?.id,
    variables: { id: info?.business?.id },
    enabled: !!info?.business?.id,
  });

  const {
    error: isErrorConnect,
    isLoading: isLoadingConnect,
    isSuccess: isSuccessConnect,
    mutateAsync: mutateConnect,
  } = useMutation(connectABusinessPartner);

  useEffect(() => {
    if (isSuccessSave) {
      addToast({
        status: 'success',
        message: 'Offre sauvegardée',
      });
    }
    refetch();
  }, [isSuccessSave]);

  useEffect(() => {
    if (isSuccessPostule) {
      addToast({
        status: 'success',
        message: "Vous avez postulé à l'offre",
      });
    }
    refetchPostule();
  }, [isSuccessPostule]);

  useEffect(() => {
    if (isSuccessUnSave) {
      addToast({
        status: 'success',
        message: 'Offre retiré des sauvegardes',
      });
    }
    refetch();
  }, [isSuccessUnSave]);

  useEffect(() => {
    if (info?.business?.id) {
      refetchInfosBusiness();
    }
  }, [info]);

  useEffect(() => {
    if (info?.business?.id) {
      setInfosBusiness(tempInfosBusiness);
    } else {
      setInfosBusiness({});
    }
  }, [info]);

  useEffect(() => {
    if (isSuccessConnect) {
      addToast({
        status: 'success',
        message: 'Demande envoyée',
      });
      handleRefetch();
    }
    if (isErrorConnect) {
      addToast({
        status: 'error',
        message: 'Erreur lors de la demande',
      });
    }
  }, [isSuccessConnect, isErrorConnect]);

  const postOffer = async () => {
    if (info?.idLaBonneAlternance) {

      setOpenNeedCV(true);
      return;

    } else {
      await mutatePostuleOffer({
        data: {
          applicant: {
            id: idUser,
          },
          offer: {
            id: info?.id,
          },
        },
      });
    }
  };

  const saveOffer = async () => {
    try {
      await mutateSavedOffer({
        data: {
          applicant: {
            id: idUser,
          },
          offer: {
            id: info?.id,
          },
        },
      });
    } catch (error) {
      console.error('Failed to save the offer:', error);
    }
  };

  const reqPartner = async () => {
    await mutateConnect({
      data: {
        schoolId: idUser,
        businessId: info?.business?.id,
      },
    });
  };

  const { push } = useRouter();

  const handleOpenVitrine = (id) => {
    push(ROUTES_PATH.BUSINESS_VITRINE, { params: { id }, from: 'map' });
  };

  const unSaveOffer = async () => {
    await mutateUnSavedOffer({
      idApplicant: idUser,
      idOffer: info?.id,
    });
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64String = reader.result.split(",")[1]; // Supprime le préfixe data
        resolve(base64String);
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    const MAX_FILE_SIZE = 3 * 1024 * 1024; // 3 Mo en octets

    if (!file || file.type !== "application/pdf") {
      addToast({
        status: 'error',
        message: "Veuillez sélectionner un fichier PDF !",
      });
      setTempCv(null);
      event.target.value = null;
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      addToast({
        status: 'error',
        message: "Le fichier est trop volumineux. La taille maximale est de 3 Mo.",
      });
      setTempCv(null);
      event.target.value = null;
      return;
    }

    try {
      const base64String = await convertToBase64(file);
      setTempCv({ content: base64String, name: file.name });
      addToast({
        status: 'success',
        message: "CV chargé avec succès !",
      });
    } catch (error) {
      console.error("Erreur lors du chargement du fichier:", error);
      addToast({
        status: 'error',
        message: "Erreur lors du chargement du fichier !",
      });
    }
  };

  const handleDeleteCv = () => {

    setTempCv(null);
    setDeleteCvTemp(true);
  };

  const closeNeedCV = () => {

    setDeleteCvTemp(false);
    setTempCv(null);
    setOpenNeedCV(false);
  };

  const MAX_FILE_SIZE = 3 * 1024 * 1024; // 3 Mo en octets

  const checkFileSize = (base64String) => {
    // Calculer la taille approximative du fichier base64
    const base64Length = base64String.length;
    const fileSizeInBytes = (base64Length * 3) / 4; // Conversion approximative base64 vers taille réelle
    return fileSizeInBytes <= MAX_FILE_SIZE;
  };

  const handleSubmit = () => {
    if (tempCv) {
      if (!checkFileSize(tempCv.content)) {
        addToast({
          status: 'error',
          message: "Le fichier est trop volumineux. La taille maximale est de 3 Mo.",
        });
        return;
      }

      if (useAsDefault) {
        dispatch({ type: "SET_CV", payload: tempCv });
        setCvNameGlobal(tempCv.name);
        setCvGlobal(tempCv.content);
      }

      postOfferWithLBA({ content: tempCv.content, name: tempCv.name });
    } else {
      if (state.cv) {
        if (!checkFileSize(state.cv)) {
          addToast({
            status: 'error',
            message: "Le fichier est trop volumineux. La taille maximale est de 3 Mo.",
          });
          return;
        }
        postOfferWithLBA({ content: state.cv, name: state.cvName });
      } else {
        addToast({
          status: 'error',
          message: "Aucun fichier sélectionné !",
        });
        return;
      }
    }
    closeNeedCV();
  };

  const postOfferWithLBA = async (cv) => {
    try {
      if (!checkFileSize(cv.content)) {
        addToast({
          status: 'error',
          message: "Le fichier est trop volumineux. La taille maximale est de 3 Mo.",
        });
        return;
      }

      const postuleOfferAPILBA = await fetch(`${process.env.NX_LBA_URL}/job/v1/apply`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + process.env.NX_LBA_API_TOKEN,
        },
        body: JSON.stringify({
          applicant_first_name: userInfo?.firstname,
          applicant_last_name: userInfo?.lastname,
          applicant_email: userInfo?.email,
          applicant_phone: userInfo?.phone,
          applicant_attachment_name: cv.name,
          applicant_attachment_content: cv.content,
          recipient_id: info?.idLaBonneAlternance,
          applicant_message: null
        }),
      });

      const postuleOfferAPILBAJson = await postuleOfferAPILBA.json();

      if (postuleOfferAPILBAJson?.statusCode) {
        addToast({
          status: 'error',
          message: "Erreur lors de l'envoi du CV, veuillez contacter le support.",
        });
        return;
      }

      // await mutatePostuleOffer({
      //   data: {
      //     applicant: {
      //       id: idUser,
      //     },
      //     offer: {
      //       id: info?.id,
      //     },
      //     fromLaBonneAlternance: true
      //   },
      // });
    } catch (error) {
      console.error("error postuleOfferAPILBA : ", error);
      addToast({
        status: 'error',
        message: "Erreur lors de l'envoi du CV",
      });
    }
  };


  console.log("info?.description : ", info?.description);
  console.log("info?.description linkifyText: ", linkifyText(info?.description));
  return (
    <div className={classes.overflowContainer}>
      <div className={classes.container}>
        <div className={cx(global.title, classes.title)}>
          <p style={{ margin: 0 }}>Informations pratiques</p>
        </div>
        <div>
          <Grid container spacing={1} className={classes.infoPratique}>
            <Grid
              item
              xs={12}
              md={6}
              lg={4}
              className={css({ marginRight: '16px' })}
            >
              <div className={classes.info}>
                <SchoolIcon className={cx(global.infoIcon, classes.itemIcon)} />
                <div>
                  <FormattedMessage id="levelStudy" /> :{' '}
                  <span>{info?.degreeLevel?.label}</span>
                </div>
              </div>

              <div className={classes.info}>
                <DescriptionIcon className={cx(global.infoIcon, classes.itemIcon)} />
                <div>
                  <FormattedMessage id="typeContrate" /> :{' '}
                  <span>{info?.contractType?.label}</span>
                </div>
              </div>

              <div className={classes.info}>
                <HourglassHalf className={cx(global.infoIcon, classes.itemIcon)} />
                <div>
                  <FormattedMessage id="dureeContrat" /> :{' '}
                  <span>{info?.contractLength} mois</span>
                </div>
              </div>

              <div className={classes.info}>
                <EuroIcon className={cx(global.infoIcon, classes.itemIcon)} />
                <div>
                  <FormattedMessage id="salaire" /> :{' '}
                  <span>{info?.salary} €/mois</span>
                </div>
              </div>

              {info?.jobAdvantages && info.jobAdvantages.length > 0 ? (
                <div
                  className={css({
                    marginTop: spacing(2),
                    display: 'flex',
                    flexDirection: 'column',
                  })}
                >
                  <div className={css({ display: 'flex' })}>
                    <LocalActivity className={cx(global.infoIcon, classes.itemIcon)} />
                    <div
                      className={css({ marginLeft: spacing(1), display: 'flex' })}
                    >
                      Avantages :{' '}
                      {/* {info?.jobAdvantages?.length === 0 &&
                      <span className={css({ marginLeft: spacing(0.5), fontWeight: 400 })}>
                        Aucun
                      </span>
                    } */}
                    </div>
                  </div>
                  <div
                    className={css({
                      marginTop: spacing(1),
                      marginLeft: spacing(2),
                    })}
                  >
                    {info.jobAdvantages.map(({ label }, index) => (
                      <li key={index}>{label}</li>
                    ))}
                  </div>
                </div>
              ) : (
                <></>
              )}
            </Grid>
            <Grid item xs={12} md={6} lg={7} className={classes.paddingTopMobile}>
              <div className={classes.info}>
                <Token className={cx(global.infoIcon, classes.itemIcon)} />
                <div>
                  <FormattedMessage id="Domaine Professionnel" /> :{' '}
                  <span>{info?.job?.sector?.domain?.label}</span>
                </div>
              </div>
              <div className={classes.info}>
                <DonutSmallIcon className={cx(global.infoIcon, classes.itemIcon)} />
                <div>
                  <FormattedMessage id="Secteur de metier" /> :{' '}
                  <span>{info?.job?.sector?.label}</span>
                </div>
              </div>
              {/*----------------*/}

              <div className={classes.info}>
                <LanguageIcon className={cx(global.infoIcon, classes.itemIcon)} />
                <div>
                  <FormattedMessage id="langRequis" /> :{' '}
                  <span>
                    {info?.workedLangage?.map(({ label }, index) =>
                      index !== info.workedLangage.length - 1
                        ? `${label}, `
                        : label
                    )}
                  </span>
                </div>
              </div>
              <div className={classes.info}>
                <DriveEta className={cx(global.infoIcon, classes.itemIcon)} />
                <div>
                  Être véhiculé : <span>{info?.transport ? 'Oui' : 'Non'}</span>
                </div>
              </div>

              <div className={classes.info}>
                <CreditCard className={cx(global.infoIcon, classes.itemIcon)} />
                <div>
                  Type de permis :{' '}
                  <span>
                    {info?.drivingLicence === 'non'
                      ? 'Aucun'
                      : info?.drivingLicence}
                  </span>
                </div>
              </div>

              <div className={classes.info}>
                <HomeRounded className={cx(global.infoIcon, classes.itemIcon)} />
                <div>
                  Présence : <span>{info?.telework}</span>
                </div>
              </div>

              <div>
                <div className={classes.info}>
                  <DateRangeRounded className={cx(global.infoIcon, classes.itemIcon)} />
                  <div>
                    Dépôt de candidature :{' '}
                    <span>
                      <FormattedDate
                        day="numeric"
                        month="numeric"
                        value={info?.publicationDate}
                        year="numeric"
                      />{' '}
                      au{' '}
                      <FormattedDate
                        day="numeric"
                        month="numeric"
                        value={info?.deadLine}
                        year="numeric"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
        <div className={classes.textContainer}>
          <div className={cx(global.title, classes.title)}>
            <p style={{ margin: 0 }}>Description</p>
          </div>
          <div className={classes.textarea}>
            {info?.description ? (
              <div className={classes.modifyLink}>
                {parse(linkifyText(info?.description))}
              </div>
            ) : (
              <div>Pas de description de l'offre</div>
            )}
          </div>
        </div>
        {infosBusiness.profile?.presentation && (
          <div className={classes.textContainer}>
            <div className={cx(global.title, classes.title)}>
              <p style={{ margin: 0 }}>Qui sommes-nous ?</p>
            </div>
            <div className={classes.modifyLink}>
              {parse(infosBusiness.profile.presentation)}
            </div>
          </div>
        )}
        <div className={css({
          marginTop: '20px',
        })}>
          {profile === 'SCHOOL' && !info?.businessExternal && !info?.businessLaBonneAlternance && (
            <div
              className={css({
                display: 'flex',
                columnGap: '10px',
                '@media screen and (min-width: 1023px)': {
                  display: 'none',
                },
                '@media screen and (max-width: 1023px)': {
                  flexDirection: 'column',
                  columnGap: 0,
                  rowGap: '10px',
                },
              })}
            >
              {partnersAccepted?.find(({ id }) => id === info?.business?.id) && (
                <Button
                  startIcon={<Partenaire />}
                  color="primary"
                  variant="contained"
                  disabled
                >
                  <FormattedMessage id="business.dashboard.dashboardBtns.partnerActive" />
                </Button>
              )}
              {accountInfos?.subscription &&
                accountInfos?.subscription.toLowerCase() == 'premium' &&
                infoBusinessAccount?.subscription &&
                infoBusinessAccount?.subscription.toLowerCase() == 'premium' &&
                !partnersAccepted?.find(({ id }) => id === info?.business?.id) &&
                !partnersRequested?.find(({ id }) => id === info?.business?.id) &&
                !partnersReceived?.find(({ id }) => id === info?.business?.id) && (
                  <Button
                    startIcon={<Partenaire />}
                    color="primary"
                    onClick={reqPartner}
                    variant="contained"
                  >
                    <FormattedMessage id="business.dashboard.dashboardBtns.partnerbtn" />
                  </Button>
                )}
              {partnersRequested?.find(({ id }) => id === info?.business?.id) ||
                partnersReceived?.find(({ id }) => id === info?.business?.id) ? (
                <Button
                  className={css({
                    width: '100%',
                    height: '43px',
                    '&:disabled': {
                      color: '#A6A6A6',
                      backgroundColor: '#E0E0E0',
                    },
                  })}
                  startIcon={<Partenaire />}
                  color="primary"
                  variant="contained"
                  disabled
                >
                  <FormattedMessage id="business.dashboard.dashboardBtns.partnerPending" />
                </Button>

              ) : null}
              {info?.business?.id && (
                <Button
                  className={cx(
                    css({
                      '&:hover': {
                        backgroundColor: '#F3F7FF',
                        color: '#5A6DA1',
                      },
                    })
                  )}
                  onClick={() => handleOpenVitrine(info?.business?.id)}
                  variant="outlined"
                >
                  <VisibilityIcon style={{ marginRight: 5 }} /> Visualiser la vitrine
                </Button>
              )}
            </div>
          )}
          {profile === 'INDIVIDUAL' && (
            <div
              className={css({
                display: 'flex',
                columnGap: '10px',
                '@media screen and (min-width: 1023px)': {
                  display: 'none',
                },
                '@media screen and (max-width: 1023px)': {
                  flexDirection: 'column',
                  columnGap: 0,
                  rowGap: '10px',
                },
              })}
            >
              {checkPostule ? (
                <Button
                  disabled
                  fullWidth
                  variant="outlined"
                >
                  Déjà postulé
                </Button>
              ) : (
                <Button
                  color="primary"
                  fullWidth
                  disabled={isLoadingPostuleOffer}
                  onClick={postOffer}
                  variant="contained"
                >
                  Postuler
                </Button>
              )}
              {!checkPostule &&
                (checkSave ? (
                  <Button
                    disabled={isLoadingUnSavedOffer}
                    onClick={unSaveOffer}
                    startIcon={<FavoriteIcon color="primary" />}
                    variant="outlined"
                  >
                    <FormattedMessage id="AddedToFavorite" />
                  </Button>
                ) : (
                  <Button
                    disabled={isLoadingSavedOffer}
                    onClick={saveOffer}
                    startIcon={<FavoriteBorderIcon />}
                    variant="outlined"
                  >
                    <FormattedMessage id="AddToFavorite" />
                  </Button>
                ))}
              {info?.business?.id && (
                <Button
                  className={cx(
                    css({
                      '&:hover': {
                        backgroundColor: '#F3F7FF',
                        color: '#5A6DA1',
                      },
                    })
                  )}
                  onClick={() => handleOpenVitrine(info?.business?.id)}
                  variant="outlined"
                >
                  <VisibilityIcon style={{ marginRight: 5 }} /> Visualiser la vitrine
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
      <Modal open={openNeedCV} onCancel={closeNeedCV}
        title="Envoyer votre CV"
      >
        <DialogContent className={classes.modalContent}>
          <Typography className={global.title} style={{ textAlign: "center" }}>Vous avez besoin de votre CV pour postuler à cette offre.</Typography>
          {deleteCvTemp ? <input type="file" accept="application/pdf" onChange={handleFileUpload} style={{ marginTop: 10 }} />
            : state.cv ? (
              // 
              <div style={{ display: "flex", alignItems: "center", marginTop: 10 }}>
                <Typography className={global.subTitle}>{tempCv?.name || state.cvName || "Aucun fichier sélectionné"}</Typography>
                <IconButton onClick={handleDeleteCv} color="secondary">
                  <Delete />
                </IconButton>
              </div>
            ) : <input type="file" accept="application/pdf" onChange={handleFileUpload} style={{ marginTop: 10 }} />}

          {tempCv && (
            <FormControlLabel
              control={<Checkbox checked={useAsDefault} onChange={() => setUseAsDefault(!useAsDefault)} />}
              label="Utiliser ce CV par défaut"
            />
          )}

          <Button onClick={handleSubmit} color="primary" variant="contained" className={classes.candidateButton}>
            Postuler
          </Button>
        </DialogContent>
      </Modal >
    </div>
  );
};

const styles = ({ spacing }) => ({
  overflowContainer: {
    overflowX: 'auto',
  },
  container: {
    padding: '30px',
    columnGap: 30,
    borderRadius: 10,
  },
  btnsContainer2: {
    display: 'flex',
    '@media only screen and (max-width:1023px)': {
      flexDirection: 'column',
      width: '100%',
    },
  },
  btnaddfavoris: {
    marginRight: 16,
    '@media only screen and (max-width:1023px)': {
      marginTop: '10px',
      width: '100%',
      marginLeft: 0,
    },
  },
  title: {
    marginBottom: '10px',
    '& p': {
      borderLeft: '3px solid #0060F9',
      paddingLeft: spacing(1),
    },
  },
  textContainer: {
    marginTop: '20px',
    '& > *': {
      textAlign: 'justify',
    },
  },
  info: {
    marginTop: '10px',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 400,
    color: '#152652',
  },
  infoPratique: {
    marginBottom: '20px',
  },
  modifyLink: {
    color: '#152652',
    wordWrap: 'break-word',
    overflowWrap: 'anywhere',
    '& p': {
      marginTop: 0,
      marginBottom: 0,
    },
    a: {
      textDecoration: 'none',
      color: '#0183FF',
    },
  },
  itemIcon: {
    color: '#0060F9',
  },
});

Informations.propTypes = {
  info: PropTypes.object,
};

export default Informations;
